import type { SiteSettings } from './types';

/* Valeurs affichées tant que l'API n'a pas répondu (et si elle est injoignable).
   Elles correspondent aux données initiales de api/sql/seed.sql. */
export const DEFAULT_SETTINGS: SiteSettings = {
  introText:
    'Tous nos plats sont faits maison. Nous apportons une attention particulière à la qualité de nos produits.',
  suggestionText: "N'hésitez pas à consulter notre tableau de suggestions et notre carte des vins.",
  hoursClosedNote: 'Fermé : Mardi, Mercredi, Lundi soir et Dimanche soir',
  hours: [
    { day: 'Lundi', time: '12h – 14h30', closed: false },
    { day: 'Mardi', time: '', closed: true },
    { day: 'Mercredi', time: '', closed: true },
    { day: 'Jeudi', time: '12h – 14h30 | 19h – 22h', closed: false },
    { day: 'Vendredi', time: '12h – 14h30 | 19h – 22h30', closed: false },
    { day: 'Samedi', time: '12h – 14h30 | 19h – 22h30', closed: false },
    { day: 'Dimanche', time: '12h – 15h', closed: false },
  ],
};
